export default __webpack_public_path__ + "static/media/blackRefresh.26bca686.svg";